export const locale = {
    lang: 'ESES',
    data: {
        loginButton: "Iniciar sesión",
        userName: "Nombre de usuario",
        emailCode: "Código de correo",
        pass: "Contraseña",
        remember: "Recordarme",
        forgotPass: "Olvidé mi contraseña",
        modules: "Módulos",
        generic: "General",
        search: "Buscar",
        logout: "Cerrar sesión",
        waitingJob: "Mis tareas pendientes",
        myStarted: "Iniciadas por mí",
        myIncluded: "En las que participo",
        myCompleted: "Mis tareas completadas",
        jobListMessageArea: "Área de mensajes de la lista de trabajos",
        jobList: "Lista de trabajos",
        formNo: "N.º de formulario",
        status: "Estado",
        starter: "Iniciador",
        generateLink: "Generar enlace",
        assigned: "Asignado a",
        timeoutDate: "Fecha de vencimiento",
        startDate: "Fecha de inicio",
        processing: "Procesando",
        you: "tú",
        history: "Historial",
        description: "Descripción",
        date: "Fecha",
        growShrink: "Ampliar/Reducir",
        close: "Cerrar",
        gridReset: "Restablecer configuración de la cuadrícula",
        columnSelect: "Selección de columnas",
        jobName: "Nombre de la tarea",
        keyword: "Palabra clave",
        completion: "Finalización",
        all: "Todo",
        completedDate: "Fecha de finalización",
        completions: "Completados",
        ongoing: "En curso",
        formName: "Nombre del formulario",
        sunday: "Domingo",
        monday: "Lunes",
        tuesday: "Martes",
        wednesday: "Miércoles",
        thursday: "Jueves",
        friday: "Viernes",
        saturday: "Sábado",
        pdfExport: "Exportar PDF",
        sendPassword: "Enviar mi contraseña",
        assignedDate: "Fecha de asignación",
        events: "Eventos",
        new: "Nuevo",
        save: "Guardar",
        formula: "Fórmula",
        selectDataSource: "Seleccionar fuente de datos",
        requiredField: "Campo obligatorio",
        makeRequiredField: "Hacer campo obligatorio",
        suffix: "Sufijo",
        valueColumn: "Columna de valor",
        showLength: "Mostrar la cantidad de tareas en las columnas",
        clearButton: "Botón Limpiar",
        allCaps: "Todo en mayúsculas",
        autoAsc: "Incremento automático",
        width: "Ancho",
        length: "Longitud",
        functions: "Funciones",
        selectElement: "Seleccionar elemento",
        selectColumn: "Seleccionar columna",
        edit: "Editar",
        changeEventActions: "Cambiar acciones de evento",
        barcode: "Código de barras",
        systemInfo: "Información del sistema",
        prefix: "Prefijo",
        max: "Máximo",
        showMinMaxInfo: "Mostrar información de mínimo y máximo",
        selectUser: "Seleccionar usuario",
        spinButton: "Botón giratorio",
        numberIncDecButton: "Botón aumentar-disminuir número",
        decimal: "Número decimal",
        numeral: "Número",
        wrongFormat: "Formato incorrecto ingresado",
        height: "Altura",
        microphone: "Micrófono",
        notifyDataReset: "Reinicio de datos",
        data: "Datos",
        dynamicData: "Datos dinámicos",
        manualData: "Datos ingresados manualmente",
        selectDataGrid: "Seleccionar tabla de datos",
        overrideUserChange: "Ignorar cambios de usuario",
        textColumn: "Columna de texto",
        makeInitialValue: "Hacer que el valor inicial sea predeterminado",
        undo: "Deshacer",
        copy: "Copiar",
        preview: "Vista previa",
        delete: "Eliminar",
        cancel: "Cancelar",
        languageSettings: "Configuración de idioma",
        messageSqlLinkDeleted: "Como ha ingresado datos manualmente, el script SQL y la dirección de conexión se eliminarán. ¿Desea continuar?",
        messageSqlLinkDeletedForMenu: "Como ha seleccionado datos como menú, el script SQL y la dirección de conexión se eliminarán. ¿Desea continuar?",
        permissions: "Permisos",
        objectid: "ID del objeto",
        fontSize: "Tamaño de la fuente",
        fontWidth: "Ancho de la fuente",
        fontStyle: "Estilo de la fuente",
        underline: "Subrayado",
        textColor: "Color del texto",
        visibility: "Visibilidad",
        textAlignment: "Alineación del texto",
        settings: "Ajustes",
        messageUnsaved: "¿Está seguro de que quiere salir sin guardar los cambios?",
        warning: "¡Advertencia!",
        userAuthorizations: "Autorizaciones de usuario",
        formPreferences: "Preferencias de formulario",
        formOpeningevent: "Evento de apertura del formulario",
        chooseConnectionAddress: "Elegir dirección de conexión",
        selectPriorty: "Seleccionar prioridad",
        loadingEditor: "Cargando editor...",
        showAddButton: "Mostrar botón para agregar fila",
        update: "Actualizar",
        connectionID: "ID de conexión",
        formPreview: "Vista previa del formulario",
        nameDisplayedform: "Nombre del formulario mostrado",
        formNamevariable: "Variable del nombre del formulario",
        category: "Categoría",
        formColor: "Color del formulario",
        generalForm: "Formulario general",
        saveForm: "Guardar formulario",
        messageNeworupdate: "Los cambios que realizó en el formulario existente se borrarán. ¿Desea continuar?",
        messageDelete: "¿Está seguro de que desea eliminar el formulario?",
        toastDeleted: "Formulario eliminado",
        toastError: "Lo sentimos, ocurrió un error durante la operación",
        alertDifferentID: "Este identificador ya se está usando en otro lugar, por favor use uno diferente.",
        confirmChanges: "Confirmar cambios",
        toastUserpermission: "El usuario no tiene permiso para diseñar formularios.",
        toastCodeeditor: "El editor de código ya está disponible",
        messageDeletesure: "Los elementos dentro de este componente se eliminarán",
        messageSure: "¿Estás seguro?",
        successful: "Exitoso",
        error: "Error",
        toastFormupdate: "Formulario actualizado",
        toastMistake: "Lo sentimos, ocurrió un error durante la operación",
        toastSaved: "Guardado",
        toastCopied: "Copiado",
        toastEmptyFormMessage: "No se ha agregado ningún elemento al formulario todavía",
        toastGiveName: "Por favor, asigne un nombre a su formulario",
        toastGiveVariableName: "Por favor, asigne un nombre a la variable de nombre de formulario",
        toastVariableNameNumberWarning: "El nombre de la variable no puede comenzar con un dígito",
        formCopy: "Copiar formulario",
        messageButtonDelete: "¿Está seguro de que desea eliminar este botón?",
        noDataFound: "No se encontraron datos",
        language: "Idioma",
        filterDatagrid: "Filtrar tabla de datos",
        addManualData: "Agregar datos manualmente en tiempo de ejecución",
        dateFormat: "Formato de fecha",
        messageSqlLinkDelete: "Como ha ingresado datos manualmente, el script SQL y la dirección de conexión se eliminarán. ¿Desea continuar?",
        timeOption: "Opción de hora",
        defaultTodaysDate: "La fecha de hoy por defecto",
        dateRange: "Rango de fechas",
        minToday: "Mínimo hoy",
        maxToday: "Máximo hoy",
        dateRangeDay: "Rango de fechas (Días)",
        enterDateRangeValue: "Ingrese el valor del rango de fechas",
        imageIdColumn: "Columna de ID",
        statusSettings: "Ajustes de estado",
        active: "Activo",
        passive: "Inactivo",
        enable: "Habilitar",
        disable: "Deshabilitar",
        visible: "Visible",
        invisible: "Invisible",
        items: "Elementos",
        showItems: "Mostrar elementos",
        array: "Matriz",
        letLabelAppear: "Mostrar etiqueta",
        add: "Agregar",
        horizontal: "Horizontal",
        vertical: "Vertical",
        text: "Texto",
        alertFillRequiredFields: "Por favor, complete los campos obligatorios",
        alertSignatureField: "El campo de la firma no puede estar vacío",
        messageApproveTransaction: "¿Aprueba la transacción?",
        button: "Botón",
        reasonforRefusal: "Motivo de rechazo",
        enterReasonRejection: "Ingrese el motivo del rechazo",
        reject: "Rechazar",
        addDeleteButton: "Agregar/Eliminar botón",
        showBorder: "Mostrar borde",
        buttons: "Botones",
        clean: "Limpiar",
        buttonSettings: "Ajustes del botón",
        saveLocation: "Ubicación de guardado",
        paymentButton: "Botón de pago",
        paymentProvider: "Proveedor de pago",
        price: "Precio",
        numberOfInstallments: "Número de cuotas",
        descriptionField: "Campo de descripción",
        current: "Actual",
        currentForm: "Formulario actual",
        name: "Nombre",
        surname: "Apellido",
        country: "País",
        city: "Ciudad",
        address: "Dirección",
        authorizations: "Autorizaciones",
        users: "Usuarios",
        user: "Usuario",
        givePermission: "Autorizar",
        groups: "Grupos",
        group: "Grupo",
        saveandSend: "Guardar y Enviar",
        approve: "Aprobar",
        sendBack: "Devolver",
        deslineAndEnd: "Rechazar y Finalizar",
        complete: "Completado",
        blue: "Azul",
        gray: "Gris",
        green: "Verde",
        red: "Rojo",
        left: "Izquierda",
        right: "Derecha",
        color: "Color",
        symbol: "Símbolo",
        position: "Posición",
        action: "Acción",
        total: "Total",
        filePath: "Ruta del archivo",
        fileName: "Nombre del archivo",
        fileUpload: "Subir archivo",
        choose: "Elegir",
        updateData: "Actualizar datos",
        show: "Mostrar",
        columns: "Columnas",
        changeEvent: "Cambiar evento",
        columnSettings: "Ajustes de columna",
        columnName: "Nombre de la columna",
        deleteColumn: "Eliminar columna",
        columnSqlScripts: "Scripts SQL de columna",
        imageNameColumn: "Columna de nombre de archivo",
        columnLanguageSetting: "Ajuste de idioma de columna",
        dataSource: "Fuente de datos",
        filter: "Filtrar",
        reset: "Restablecer",
        column: "Columna",
        image: "Imagen",
        searchLocation: "Buscar ubicación...",
        draggable: "Arrastrable",
        usersCanChange: "Los usuarios pueden cambiar",
        multiMarker: "Marcador múltiple",
        markerLimit: "Límite de marcadores (0: ilimitado)",
        meetingType: "Tipo de reunión",
        meetingName: "Nombre de la reunión",
        loadingFiles: "Cargando archivos...",
        fileSizeExceeded: "Se excedió el tamaño del archivo",
        filesLoaded: "Archivos cargados",
        condition: "Condición",
        value: "Valor",
        connectionAddress: "Dirección de conexión",
        imageTypeColumn: "Columna de tipo de archivo",
        visibleColumn: "Columna visible",
        selectionMode: "Modo de selección",
        selectMode: "Modo de selección",
        datagridFiltering: "Filtrado de tabla de datos",
        imageDataColumn: "Columna de archivo",
        selectDataColumn: "Seleccionar columna de la tabla de datos",
        dataFormat: "Formato de datos",
        photoPreview: "Vista previa de la foto",
        videoPreview: "Vista previa de video",
        displayPhoto: "Mostrar foto",
        displayVideo: "Mostrar video",
        imageColumn: "Columna de imagen",
        videoColumn: "Columna de video",
        columnNameAppear: "Nombre de la columna que se mostrará",
        selected: "Seleccionado",
        inStock: "En stock",
        messageSave: "¿Está seguro de que desea guardar sus cambios?",
        gallery: "Galería",
        dollar: "dólar",
        sterling: "libra",
        underPhoto: "Debajo de la foto",
        topPhoto: "Encima de la foto",
        byCategory: "Por categoría",
        dashboardShowHide: "Mostrar/Ocultar Panel de Control",
        showDetail: "Mostrar detalle",
        hideDetail: "Ocultar detalle",
        decrease: "Disminuir",
        increase: "Aumentar",
        watch: "ver",
        watchMovie: "Ver película",
        noRecordsFound: "¡No se encontraron registros!",
        appearance: "Apariencia",
        numberofColumns: "Cantidad de columnas",
        pagingRecords: "Registros de paginación",
        detailLocation: "Ubicación del detalle",
        hideImages: "Ocultar imágenes",
        quantityCategoryDisable: "Desactivar categoría cuando se aumenta la cantidad",
        general: "General",
        idColumn: "Columna de ID",
        availableQuantity: "Cantidad disponible",
        categoryColumn: "Columna de categoría",
        photoColumn: "Columna de foto",
        titleColumn: "Columna de título",
        priceColumn: "Columna de precio",
        updatablePrice: "Precio modificable",
        videoGallery: "Galería de videos",
        uniqueComponent: "Componente único",
        showVariant: "Mostrar variante",
        transferTotalAmount: "Transferir el monto total",
        title: "Título",
        hide: "Ocultar",
        detail: "Detalle",
        priceQuery: "Consulta de precio",
        quantityQuery: "Consulta de cantidad",
        uniqueComponentError: "Error de componente único",
        joinColumn: "Columna de unión",
        nameColumn: "Columna de nombre",
        variantScript: "Script de variante",
        variantImages: "Imágenes de variante",
        variantJoinColumn: "Columna de unión de variante",
        showAll: "Mostrar todo",
        showSelected: "Mostrar seleccionados",
        showByCategory: "Mostrar por categoría",
        showInStock: "Mostrar en stock",
        notYetAdded: "Aún no se ha agregado",
        added: "Agregado",
        startingDate: "Fecha de inicio",
        endDate: "Fecha de finalización",
        themeFeatures: "Características del tema",
        menu: "Menú",
        selectMenu: "Seleccionar menú",
        selectSubmenu: "Seleccionar submenú",
        selectMenuBrowser: "Seleccionar navegador de menú",
        nameElement: "Elemento de nombre",
        subject: "Asunto",
        picture: "Imagen",
        pictureElement: "Elemento de imagen",
        startingDateElement: "Elemento de fecha de inicio",
        endDateElement: "Elemento de fecha de finalización",
        usersCanEdit: "Los usuarios pueden editar",
        thisPropertyCant: "Esta propiedad no se puede usar si los datos provienen de SQL",
        calendarDisplay: "Características de visualización de calendario",
        monthly: "Mensual",
        generalDisplayLunarDays: "Vista general de los días del mes",
        agenda: "Agenda",
        listofWeeklyEvents: "Lista de eventos semanales",
        weekly: "Semanal",
        weekend: "Fin de semana",
        generalDisplayWeekDays: "Vista general de días laborables",
        showWeekendDaysWhileWeekdays: "Mostrar días de fin de semana mientras se muestran días laborales",
        daily: "Diario",
        listofDailyEvents: "Lista de eventos diarios",
        startTime: "Hora de inicio",
        endTime: "Hora de fin",
        changeDefaultColor: "Cambiar colores predeterminados",
        weekdayColor: "Color para días laborables",
        weekendColor: "Color para días de fin de semana",
        eventColor: "Color del evento",
        groupBySql: "Agrupar según SQL",
        groupColumnName: "Nombre de la columna de agrupación",
        assignedColumnName: "Nombre de la columna asignada",
        taskPriortiyColumnName: "Nombre de la columna de prioridad de tarea",
        taskSubjectColumnName: "Nombre de la columna de asunto de tarea",
        taskDetailColumnName: "Nombre de la columna de detalle de tarea",
        taskQuery: "Consulta de tarea",
        taskKeyExpression: "Expresión de clave de tarea",
        taskTitleExpression: "Expresión de título de tarea",
        taskStartDateExpression: "Expresión de fecha de inicio de tarea",
        taskEndDateName: "Nombre de fecha de finalización de tarea",
        taskParentExpression: "Expresión de tarea superior",
        taskProgressExpression: "Expresión de progreso de tarea",
        taskColorExpression: "Expresión de color de tarea",
        taskConnections: "Conexiones de tarea",
        diagramClear: "¿Está seguro de que desea limpiar el diagrama? Esta acción no se puede deshacer.",
        uniqueComponentMenuCloneWarning: "Por favor, modifique el componente único antes de clonarlo.",
        filesLoading: "Cargando archivos...",
        couldnotbeLoaded: "no se pudo cargar.",
        fileSizeLimit: "Límite de tamaño de archivo",
        filesUploaded: "Archivos cargados",
        filesWillDeleted: "¡Los archivos se eliminarán!",
        filesSureDelete: "¿Está seguro de que desea eliminar los archivos?",
        fileDelete: "¿Desea eliminar el archivo?",
        uploadedPhotos: "Fotos subidas",
        maxSize: "Tamaño máximo",
        center: "Centrar",
        size: "Tamaño",
        canItBeUpdated: "¿Puede actualizarse después de la instalación?",
        uploadedFiles: "Archivos subidos",
        type: "Tipo",
        showdeleteOldData: "Mostrar opciones para eliminar datos antiguos",
        videoBrowser: "Su navegador no soporta la etiqueta de video.",
        deleted: "Eliminado",
        theseComponentElementsDeleted: "Estos elementos del componente se eliminarán.",
        invalidTarget: "Destino inválido",
        ridge: "Línea continua",
        dotted: "Punteada",
        dashed: "Trazada",
        addRowColumn: "Agregar fila/columna",
        dataPagingShow: "Paginación de datos",
        borderType: "Tipo de borde",
        maxCharacters: "Máximo de caracteres",
        edgeThickness: "Grosor del borde",
        lineSpacing: "Espaciado de línea",
        settingsRow: "Ajustes de fila/columna",
        addRow: "Agregar fila",
        deleteRow: "Eliminar fila",
        rowPermission: "Permisos de fila",
        addTabs: "Agregar pestañas",
        deletePanel: "Eliminar panel",
        tabPermission: "Permiso de pestaña",
        addPanel: "Agregar panel",
        panelPermission: "Permisos de panel",
        backgroundColor: "Color de fondo",
        saveAndCloseChildForm: "¿Desea guardar y cerrar este subformulario al abrir un nuevo formulario?",
        icon: "Icono",
        selectForm: "Seleccionar formulario",
        fontColor: "Color de la fuente",
        minCharacters: "Mínimo de caracteres",
        generalCategory: "Categoría General",
        removeRow: "¿Está seguro de que desea eliminar el registro?",
        send: "Enviar",
        declineFinish: "Rechazar y Finalizar",
        finish: "Finalizar",
        noData: "Sin datos",
        createEditMenu: "Crear/Editar Menú",
        addNewBreakdown: "Agregar nuevo detalle",
        addForm: "Agregar Formulario",
        addBottomBreak: "Agregar detalle inferior",
        addNode: "Agregar nodo",
        topCategory: "Categoría principal",
        explanation: "Explicación",
        browserTitle: "Título del navegador",
        formTitle: "Título del formulario",
        addSqlColumn: "Agregar columna SQL",
        formBg: "Fondo del formulario",
        codeEditor: "Editor de código",
        authorityType: "Tipo de autoridad",
        viewOnly: "Solo vista",
        dark: "Oscuro",
        white: "Blanco",
        hightBlack: "Negro",
        run: "Ejecutar",
        fileLink: "Enlace de archivo",
        givePasswordToTheLink: "Asignar contraseña al enlace",
        giveTheLinkAnExpirationDate: "Asignar fecha de expiración al enlace",
        rowColor: "Color de la fila",
        operator: "Operador",
        flowOfForm: "Flujo del formulario",
        columnWidth: "Ancho de la columna",
        alignLeft: "Alinear a la izquierda",
        alignRight: "Alinear a la derecha",
        alignButton: "Alinear botón",
        imageTableNameColumn: "Nombre de la tabla",
        uploadBg: "Subir fondo",
        selectFile: "Seleccionar archivo",
        dropFile: "Arrastre el archivo aquí",
        alwaysRoundUp: "Siempre redondear hacia arriba",
        alwaysRoundBot: "Siempre redondear hacia abajo",
        default: "Predeterminado",
        deleteOldDataTable: "¿Eliminar datos antiguos de la tabla?",
        deleteOldData: "¿Eliminar datos antiguos?",
        integer: "Número entero",
        double: "Número decimal",
        pleaseFillFields: "Por favor, complete los campos obligatorios.",
        toastColumnNameNumber: "El nombre de la columna no puede comenzar con un dígito",
        areYouSure: "¿Está seguro?",
        columnDeleted: "La columna se eliminará",
        allColumnDeleted: "Se eliminarán todas las columnas",
        idCantStartNumber: "El ID no puede comenzar con un dígito",
        uploadFile: "Subir archivo",
        fileViewer: "Visor de archivos",
        ok: "Aceptar",
        map: "Mapa",
        editPanel: "Editar panel",
        filterColumnName: "Filtrar nombre de columna",
        hintExamples: "TotalCantidad, ejemplo:Salario",
        columnLanguageSettings: "Configuración de idioma de columna",
        fileColumn: "Columna de archivo",
        fileNameColumn: "Columna del nombre de archivo",
        extensionColumn: "Columna de extensión",
        multipleSelection: "Selección múltiple",
        addSelectionsRows: "Agregar selecciones como filas",
        mapSettings: "Configuración de mapa",
        formatAndFeatures: "Formato y características",
        enterDateRange: "Ingrese el valor del rango de fechas",
        filesCanUploadedUsers: "Los usuarios pueden subir archivos",
        barcodeColumn: "Columna de código de barras",
        autoAscend: "Incremento automático",
        roundType: "Tipo de redondeo",
        font: "Fuente",
        columnProcess: "Proceso de columna",
        exportColumnTotal: "Exportar columna total",
        outsideElementDisabled: "Elementos externos deshabilitados",
        chat: "Chat",
        languages: "Idiomas",
        display: "Imagen",
        enterYourComment: "Ingrese su comentario",
        comment: "Comentarios",
        fileUploaded: "Archivo subido",
        pdfViewIsButton: "Mostrar como botón",
        takeScreenshot: "Tomar captura de pantalla",
        alertText: "Texto de alerta",
        clearButtonVisible: "Mostrar botón de limpiar",
        allText: "Todo",
        letter: "Solo letras",
        letterandnumber: "Letras y números",
        letterandsymbol: "Letras y símbolos",
        numberandsymbol: "Números y símbolos",
        showIDColumn: "Mostrar columna de ID",
        showCopyButton: "Mostrar botón de copiar",
        showDeleteButton: "Mostrar botón de eliminar",
        showCheckboxButton: "Mostrar botón de casilla de verificación",
        autoRowHeight: "Altura de fila automática",
        exportImport: "Importar/Exportar formulario",
        export: "Exportar",
        import: "Importar",
        toastImport: "La importación del formulario se completó con éxito.",
        warningApproveImport: "Realice los ajustes necesarios y confirme la operación. Importar el formulario cerrará el formulario actual",
        defaultTodaysDateWithTime: "Fecha y hora de hoy por defecto",
        filterVisible: "Mostrar filtro de columna",
        updatetableMaxQuantity: "Cantidad máxima de actualización",
        hideQuantity: "Ocultar selección de cantidad",
        disableQuantityTextbox: "Desactivar campo de texto de cantidad",
        multiplesOfQuantity: "Aumentar/disminuir múltiplos de la cantidad",
        justnumber: "Solo número",
        paymentHourWarning: "No es posible realizar pagos fuera de la hora de control.",
        addColumn: "Agregar columna",
        mailSettings: "Opciones de correo electrónico",
        newTaskMailDetail: "Texto del correo cuando se asigna una nueva tarea",
        updateTaskMailDetail: "Texto del correo cuando se edita la tarea",
        deleteTaskMailDetail: "Texto del correo cuando se elimina la tarea",
        completeTaskMailDetail: "Texto del correo cuando se completa la tarea",
        taskOnDropMail: "Texto del correo cuando se mueve la tarea",
        selectSMTP: "Seleccionar dirección SMTP",
        taskCreator: "Creador de la tarea",
        taskEndDate: "Fecha de finalización de la tarea",
        tags: "Etiquetas",
        taskStartDate: "Fecha de inicio de la tarea",
        taskAssigned: "Persona asignada a la tarea",
        taskDetail: "Detalle de la tarea",
        taskSubject: "Asunto de la tarea",
        taskPri: "Prioridad de la tarea",
        taskEdit: "Editar tarea",
        addTask: "Agregar tarea",
        taskStatus: "Estado de la tarea",
        excelExportSettings: "Ajustes de exportación a Excel",
        excelExportRequiredColor: "Color de la columna de campo obligatorio",
        allDataExcelExport: "Exportar datos a Excel",
        warningApproveImportReport: "Realice las configuraciones necesarias y confirme la operación. Importar el informe cerrará el informe actual.",
        reportName: "Nombre del informe",
        emptyReportName: "Por favor, agregue un nombre de informe en el lado derecho.",
        old: "antiguo",
        upperNode: "Desglose superior",
        pdfViewStaticPdf: "Mostrar como archivo estático",
        actions: "Acciones",
        loading: "Cargando",
        exportDataToExcell: "Exportar todos los datos a Excel",
        showRefreshIcon: "Icono de actualización",
        headerFilter: "Filtro de cabecera",
        filterRowVisible: "Mostrar cuadro de búsqueda en la columna",
        password: "Contraseña",
        categories: "Categorías",
        pressEnter: "Presione Enter",
        historyColumnValue: "Columna de historial de datos",
        hideMobile: "Ocultar en dispositivos móviles",
        align: "Alinear",
        theme: "Tema",
        info: "Información",
        showTitle: "Mostrar título",
        purple: "Morado",
        brown: "Marrón",
        yellow: "Amarillo",
        turnOnComments: "Habilitar comentarios",
        showContent: "Mostrar contenido",
        canBeHidden: "Se puede ocultar",
        allowEdit: "Permitir edición",
        allowDelete: "Permitir eliminación",
        allowAdd: "Permitir adición",
        allowCopy: "Permitir copia",
        toastDeleteErrorMessage: "Este componente se utiliza en los scripts de preferencias del formulario. No se puede eliminar.",
        formOpeningMultiElementEvent: "Evento de creación de múltiples elementos del formulario",
        resetDatagridLocalSettings: "Restablecer configuración local de la tabla de datos",
        loginP1: "River, como la memoria corporativa de su organización, reúne experiencias pasadas, éxitos, fracasos, lecciones aprendidas, cultura y valores como un recurso de referencia integral para futuras decisiones y acciones. Esta memoria corporativa abarca la historia de la organización, procesos de trabajo, la experiencia de los empleados, experiencias de clientes, el desarrollo de productos y servicios y mucha más información. Estos datos proporcionan una guía para las futuras metas y estrategias de la empresa.",
        loginP2: "River, con su estructura compatible con aplicaciones web y móviles nativas avanzadas, ayuda a que sus procesos comerciales sean más eficientes y efectivos. Puede acceder a todo lo que necesite desde su computadora, tableta o teléfono inteligente.",
        loginP3: "Los tableros Kanban y los diagramas de Gantt son herramientas extremadamente útiles para visualizar un proyecto o flujo de trabajo. Ofrecen una representación visual de los elementos de trabajo, su estado actual y el flujo de trabajo en diferentes etapas. Esto facilita la identificación de cuellos de botella, la priorización de tareas y el aumento de la eficiencia operativa. Los tableros Kanban y los diagramas de Gantt son herramientas prácticas y efectivas para la gestión de proyectos ágiles, desarrollo de software y otros procesos de mejora continua.",
        loginConnect: "Conectar",
        loginEmailOk: "Confirmar",
        loginText: "Inicio de sesión",
        loginEmailText: "Confirmación por correo electrónico",
        loginMobileText: "Confirmación por móvil",
        mobileConfirmInfoText:"Se envió una notificación móvil. Haga clic en la notificación para confirmar el inicio de sesión.",
        loginRightMore: "Más",
        loginHeaderP1: "Su memoria corporativa",
        loginHeaderP2: "Movilidad",
        loginHeaderP3: "Potencia gráfica",
        kanbanaddTasks: "Agregar tarea Kanban",
        taskstatusDesciption: "Permite mostrar el nombre de la columna en la que se asignará la tarea Kanban.",
        tasksubjectDescription: "Permite introducir el título de la tarea Kanban. El título Kanban es obligatorio.",
        taskassignedToTask: "Grupos asignados a la tarea",
        taskassignedTaskDescription: "Permite seleccionar los grupos a los que se asignará la tarea Kanban.",
        addedForTasks: "Agregados para la tarea",
        taskAssignedInfoDescription: "Personas a informar sobre la tarea",
        assignedInfo: "Personas a informar",
        groupInfo: "Grupos a informar sobre la tarea",
        sortEnd: "Ordenar por fecha de finalización",
        sender: "Remitente",
        forward: "Reenviar",
        attachments: "Archivos adjuntos",
        taskdetailDescription: "Permite introducir los detalles de la tarea Kanban. Los detalles son obligatorios.",
        taskassignedDescription: "Permite seleccionar los usuarios a los que se asignará la tarea Kanban. Se requiere al menos un usuario.",
        taskstartdateDescription: "Permite seleccionar la fecha de inicio de la tarea Kanban. De forma predeterminada, se establece en la hora de creación de la tarea.",
        taskenddateDescription: "Permite seleccionar la fecha de finalización de la tarea Kanban. De forma predeterminada, se establece una semana después de su creación.",
        taskpriDescription: "Permite seleccionar el nivel de prioridad de la tarea Kanban. Por defecto, la fecha de finalización de la tarea es una semana después de su creación.",
        tagsDescription: "Permite agregar etiquetas a la tarea Kanban. Las etiquetas se separan con comas.",
        outlookDescription: "Si la opción 'Agregar a Outlook' está activa, la tarea se agrega automáticamente al calendario de Outlook tras iniciar sesión en la cuenta de Outlook.",
        taskAssInfoDescription: "Campo para añadir personas que no estén asignadas a la tarea pero que deban tener conocimiento de ella. Estas personas no pueden realizar acciones sobre la tarea.",
        receiver: "Receptor",
        draft: "Borrador",
        spam: "Correo no deseado",
        filterstate: "Filtrar por estado",
        checkForspelling: "Verificar ortografía",
        emailToForward: "Correo a reenviar",
        lowImpMails: "Correos de baja importancia",
        normalImpMails: "Correos de importancia normal",
        highImpEmails: "Correos de alta importancia",
        showReadMails: "Mostrar correos leídos",
        groupinfoDescription: "Campo para añadir grupos que no estén asignados a la tarea pero que deban tener conocimiento de ella. Estos grupos no pueden realizar acciones sobre la tarea.",
        timeoutMission: "Hora en la que comienza la alerta previa a la finalización",
        timeoutmissionDescription: "Se utiliza para indicar el momento en que comenzará la alerta previa a la fecha de finalización de la tarea Kanban.",
        taskperiodDescription: "Se utiliza para indicar la frecuencia con la que se enviarán recordatorios al acercarse la fecha de finalización de la tarea Kanban.",
        taskProgress: "Progreso de la tarea",
        taskProgressDescription: "Se utiliza para indicar el estado de progreso de la tarea Kanban. Se puede visualizar en la gráfica de Gantt.",
        updatekanbanTask: "Actualizar tarea Kanban",
        taskcreatorDescription: "Muestra la persona que creó la tarea Kanban.",
        uploadfileDescription: "Se utiliza para cargar archivos a la tarea Kanban. Los archivos se guardan en DMS.",
        infoPersons: "Personas a informar",
        warningtime: "Hora de alerta",
        taskPeriod: "Período de la tarea",
        taskProgresSatus: "Estado de progreso de la tarea",
        makeTask: "Persona que creó la tarea",
        addedforTasks: "Agregados para la tarea",
        outlookIntegration: "Integración con Outlook",
        loginoutlook: "Iniciar sesión en el calendario de Outlook",
        fetchoutlook: "Obtener datos del calendario de Outlook",
        progressStatus: "Estado de progreso",
        taskColors: "Colores de la tarea",
        addcalendarTask: "Agregar tarea al calendario",
        updatetaskCalendar: "Actualizar tarea de calendario",
        statusComplete: "Filtrar estado de finalización",
        priorityFilter: "Filtrar por prioridad",
        columnFilter: "Filtrar por columna",
        assignPerson: "Personas asignadas",
        assignGroup: "Grupos asignados",
        noTask: "No se encontró ninguna tarea",
        resetSort: "Restablecer orden",
        sortASC: "Ordenar A - Z",
        sortDESC: "Ordenar Z - A",
        sortAppointment: "Ordenar por fecha de asignación",
        trash: "Papelera",
        showOlderMail: "Mostrar correos más antiguos",
        mailNotFound: "No se encontró el correo",
        sendNewMail: "Enviar nuevo correo",
        showUnreadMails: "Mostrar correos no leídos",
        updateColumnMail: "Mensaje para el destinatario cuando se agrega una tarea a la columna",
        addTaskToOutlook: "Agregar la tarea también a Outlook",
        enterYourMessage: "Ingrese su mensaje",
        reminder: "Recordatorio",
        determinedToTask: "Tiempo determinado para la tarea",
        remainingTime: "Tiempo restante",
        hours: "Horas",
        withoutPriority: "Sin prioridad",
        lowPri: "Prioridad baja",
        normalPri: "Prioridad media",
        highPri: "Prioridad alta",
        showAllTasks: "Mostrar todas",
        showIncompleteTasks: "Mostrar incompletas",
        showCompeletedTasks: "Mostrar completadas",
        reportDesigner: "Diseñador de informes",
        fileManagementSystem: "Sistema de gestión de archivos",
        formDesigner: "Diseñador de formularios",
        boardDesigner: "Diseñador de tableros",
        themeSettings: "Características del tema",
        social: "Social",
        profile: "Perfil",
        contacts: "Contactos",
        files: "Archivos",
        pages: "Páginas",
        noResultsFound: "No se encontraron resultados",
        processes: "Procesos",
        filterByStatus: "Filtrar por estado",
        filterByPri: "Filtrar por prioridad",
        filterByCol: "Filtrar por columna",
        todoAddTasks: "Agregar tarea To-Do",
        addLabel: "Introduzca la etiqueta",
        showWithSubTasks: "Mostrar aquellas con subtareas",
        riverBoard: "Tableros de River",
        notify: "Notificaciones",
        likedYourPost: "Le gustó tu publicación",
        likedYourComment: "Le gustó tu comentario",
        systemNotify: "Notificaciones del sistema",
        readAllNotify: "Marcar todas las notificaciones como leídas",
        recommendedUsers: "Usuarios recomendados",
        suggestedPosts: "Publicaciones sugeridas",
        sPostReposted: "Su publicación fue compartida nuevamente",
        shareSomething: "Comparte algo",
        updatePost: "Actualizar publicación",
        ifYouDoNotSelectGroup: "Si no selecciona un grupo, todos podrán ver su publicación",
        addComment: "Agregar comentario",
        sendComment: "Enviar comentario",
        areYouSureYouWantToDeleteThisPost: "¿Está seguro de que desea eliminar esta publicación?",
        yes: "Sí",
        no: "No",
        deletePost: "Eliminar publicación",
        postSuccesfullyDeleted: "Publicación eliminada con éxito",
        deleteComment: "Eliminar comentario",
        areYouSureYouWantToDeleteThisComment: "¿Está seguro de que desea eliminar este comentario?",
        commentSuccesfullyDeleted: "Comentario eliminado con éxito",
        sharePost: "Compartir publicación",
        areYouSureYouWantToShareThisPost: "¿Está seguro de que desea compartir esta publicación?",
        repostedSuccessfully: "Compartido nuevamente con éxito",
        upload: "Subir",
        refresh: "Actualizar",
        allowedExtentions: "Extensiones permitidas: JPG, GIF o PNG. Tamaño máximo de archivo",
        systemLandingPagePreference: "Preferencia de página de inicio",
        allownonadminuserstosearchforotherusers: "Permitir que usuarios no administradores busquen a otros usuarios",
        passwordChange: "Cambio de contraseña",
        newPassword: "Nueva contraseña",
        retypethenewpassword: "Reingresar la nueva contraseña",
        notifications: "Notificaciones",
        showWhoLikesYourPost: "Mostrar quiénes dieron 'Me gusta' a sus publicaciones",
        showWhoLikesYourComment: "Mostrar quiénes dieron 'Me gusta' a sus comentarios",
        aboutMe: "Sobre mí",
        bio: "Biografía",
        dateOfBirth: "Fecha de nacimiento",
        website: "Sitio web",
        phone: "Teléfono",
        saveChanges: "Guardar cambios",
        username: "Nombre de usuario",
        content: "Contenido",
        projectManagement: "Gestión de proyectos",
        addPage: "Agregar página",
        addFolder: "Agregar carpeta",
        showUsers: "Usuarios que pueden ver",
        showGroups: "Grupos que pueden ver",
        readonlyUsers: "Solo lectura (Usuarios)",
        readonlyGroups: "Solo lectura (Grupos)",
        columnHeight: "Altura de la columna",
        showKanbanCount: "Mostrar el número de tareas Kanban",
        kanbanSettings: "Configuración de Kanban",
        gantSettings: "Configuración de Gantt",
        schedulerSettings: "Configuración de calendario",
        showRowLines: "Mostrar líneas de fila",
        activateOutlookConnection: "Activar conexión con Outlook",
        selectOutlookColumn: "Seleccione la columna de Outlook",
        selectSMTPPopoverText: "Seleccione la dirección SMTP que se usará para Kanban, Gantt, Calendario o To-Do.",
        menuFilePathId: "ID de carpeta del menú River",
        recycleBinPathName: "Nombre de la carpeta Papelera de River",
        recycleBinPathId: "ID de la carpeta Papelera de River",
        fileNameChangedMessage: "El nombre del archivo se cambió con éxito.",
        fileNameChangedErrorMessage: "No se pudo cambiar el nombre del archivo.",
        fileCreatedMessage: "Archivo creado con éxito.",
        newTaskMailDetailPopoverText: "Contenido para el correo automático cuando se asigna una nueva tarea en Kanban, Gantt, Calendario o To-Do.",
        taskOnDropMailPopoverText: "Contenido para el correo automático cuando se cambia de columna una tarea en Kanban, Gantt, Calendario o To-Do.",
        createdBy: "Creado por",
        updatedBy: "Actualizado por",
        createdDate: "Fecha de creación",
        updatedDate: "Fecha de actualización",
        folderPermissionSettings: "Configuración de permisos de carpeta",
        quantity: "Cantidad",
        fileManagementPermissionSettings: "Configuración de permisos de gestión de archivos",
        fileNotFoundErrorText: "No se encontró ningún archivo que coincida con sus criterios de búsqueda.",
        fileSearchInfoText: "La búsqueda de archivos está en curso",
        updateTaskMailDetailPopoverText: "Contenido para el correo automático cuando se edita una tarea en Kanban, Gantt, Calendario o To-Do.",
        deleteTaskMailDetailPopoverText: "Contenido para el correo automático cuando se elimina una tarea en Kanban, Gantt, Calendario o To-Do.",
        completeTaskMailDetailPopoverText: "Contenido para el correo automático cuando se completa una tarea en Kanban, Gantt, Calendario o To-Do.",
        selectOutlookColumnPopoverText: "Seleccione la columna en la que se agregarán las tareas desde Outlook.",
        createFolder: "Crear archivo",
        versionHistory: "Historial de versiones",
        subFileManager: "Gestor de archivos secundarios",
        removeSubFiles: "Eliminar subarchivo",
        parentFolder: "Carpeta principal",
        deletePermanently: "Eliminar permanentemente",
        recover: "Recuperar",
        groupPermissions: "Permisos del grupo",
        allowUpload: "Permitir subida de archivos",
        allowView: "Permitir visualización de archivos",
        allowDownload: "Permitir descarga de archivos",
        permissionType: "Tipo de permiso",
        applyToSubFolders: "Aplicar a todas las subcarpetas",
        newFolderName: "Nuevo nombre de archivo",
        tagTips: "Las etiquetas deben comenzar con '#'. Solo pueden incluir letras y números",
        addAsNewVersion: "Subir como nueva versión",
        addAndChangeName: "Cambiar nombre y subir",
        skip: "Omitir",
        fileExistError: "Ya existe un archivo con el mismo nombre en la carpeta de destino",
        processFileShow: "Mostrar carpeta de procesos River",
        processFilePathName: "Nombre de carpeta de procesos River",
        processFilePathId: "ID de carpeta de procesos River",
        menuFileShow: "Mostrar carpeta del menú River",
        menuFilePathName: "Nombre de carpeta del menú River",
        fileCreatedErrorMessage: "No se pudo crear el archivo.",
        fileDeletedessage: "Archivo eliminado con éxito.",
        fileDeletedErrorMessage: "Error al eliminar el archivo.",
        fileMovedMessage: "Archivo movido con éxito.",
        fileMovedErrorMessage: "Error al mover el archivo.",
        fileCopyMessage: "Archivo copiado con éxito.",
        fileCopyErrorMessage: "Error al copiar el archivo.",
        fileDownloadMessage: "Archivo descargado con éxito.",
        fileDownloadErrorMessage: "Error al descargar el archivo.",
        fileSizeShowErrorMessage: "No podemos mostrar el archivo debido a su gran tamaño. Por favor descárguelo.",
        unsupportedFile: "Archivo no compatible",
        fileNameError: "Ya existe un archivo con este nombre. Pruebe con un nombre diferente.",
        fileGivePermissionMessage: "Los permisos del archivo se configuraron correctamente.",
        fileGivePermissionErrorMessage: "Error al configurar permisos del archivo. No se pudo guardar.",
        groupName: "Nombre del grupo",
        createGroup: "Crear grupo",
        conversation: "Conversaciones",
        startConversation: "Iniciar conversación",
        userNotFound: "Usuario no encontrado",
        chatNotFound: "Chat no encontrado",
        themeTypeLight: "Claro",
        themeTypeBorderedLight: "Con bordes",
        themeHalfDark: "Medio oscuro",
        themeDark: "Oscuro",
        themeRouteAnimation: "Animación de transición",
        themeRouteAnimationFadeInLeft: "Desvanecer desde la izquierda",
        themeRouteAnimationZoomIn: "Acercar",
        themeRouteAnimationFadeIn: "Desvanecer",
        themeRouteAnimationNone: "Ninguno",
        themeMenuType: "Tipo de menú",
        themeMenuTypeHorizontal: "Horizontal",
        themeMenuTypeVertical: "Vertical",
        themeMenuCollapse: "Menú colapsado",
        themeMenuHidden: "Menú oculto",
        themeNavbarColor: "Color de la barra de navegación",
        themeNavbarType: "Tipo de barra de navegación",
        themeSticky: "Fija",
        themeStatic: "Estática",
        themeFloating: "Flotante",
        themeHidden: "Oculta",
        themeFooterType: "Tipo de pie de página",
        catalog: "Catálogo",
        riverBoards: "Tableros River",
        clipboardDesigner: "Diseñador de tableros",
        desingMode: "Estás en modo de diseño",
        editPage: "Editar página",
        rename: "Renombrar",
        exportToPdf: "Exportar como PDF",
        exportToExcel: "Exportar como Excel",
        revenueReport: "Informe de ingresos",
        header: "Encabezado",
        connection: "Conexión",
        primaryKey: "Clave primaria",
        secondaryKey: "Clave secundaria",
        completedKey: "Clave de finalización",
        countKey: "Clave de conteo",
        statusKey: "Clave de estado",
        progressConnection: "Conexión de progreso",
        progressScript: "Script de progreso",
        progressPrimaryKey: "Clave primaria de progreso",
        progressCountKey: "Clave de conteo de progreso",
        progressPercentageKey: "Clave de porcentaje de progreso",
        progressColorKey: "Clave de color de progreso",
        keyColumn: "Columna de valor",
        currency: "Moneda",
        whitePage: "Página en blanco",
        noReportSelected: "No se seleccionó ningún informe",
        noTypeSelected: "No se seleccionó ningún tipo de informe",
        whitePageReports: "Informe de página en blanco",
        addBranch: "Agregar desglose/subdesglose",
        branchName: "Nombre del desglose",
        rowNumber: "Número de fila",
        reportTypeSelect: "Seleccione el tipo de informe",
        reportDescription: "Descripción del informe...",
        useWeb: "Usar en web",
        useMobile: "Usar en móvil",
        mainScript: "Script principal",
        prerunScript: "¿Ejecutar un script previo?",
        preScript: "Script previo",
        testIt: "Probar",
        selectAll: "Seleccionar todo",
        addReport: "Agregar informe",
        selectReportType: "Seleccione el tipo de informe",
        reportType: "Tipo de informe",
        reportDesingPermission: "El usuario no tiene permiso para diseñar informes.",
        reportImportedOpenLeftMenu: "Informe importado. Puede abrirlo desde el menú izquierdo.",
        forReportExport: "Para exportar el informe, primero debe seleccionar un informe.",
        anErrorOccurred: "Ocurrió un error",
        reportDeleted: "Informe eliminado",
        branchDeleted: "Desglose eliminado",
        addBranchName: "Por favor ingrese el nombre del desglose",
        addedBranch: "Desglose agregado",
        selectConnectionAddress: "Por favor seleccione la dirección de conexión",
        enterSqlScript: "Por favor ingrese el script SQL",
        enterReportName: "Por favor ingrese el nombre del informe",
        reportAdded: "Informe agregado",
        numberOfDataToBeProcessed: "Conexión exitosa. Cantidad de datos a procesar:",
        dataNotFoundCheckYourConnection: "¡No se encontraron datos! Verifique su conexión y su script SQL",
        connectionNotFoundCheckYourConnection: "¡No se pudo establecer la conexión! Verifique su conexión y su script SQL",
        fillConnectionAndSql: "Por favor complete la conexión y el script SQL",
        allTypesActivate: "Al ver el informe, activar todos los tipos",
        passwordRequired: "La contraseña es obligatoria",
        showLess: "Mostrar menos",
        showMore: "Mostrar más",
        authority: "Autoridad",
        preScriptDescription: "Descripción del script previo",
        enterReportFilters: "Ingrese los filtros del informe",
        gridDesigner: "Diseñador de cuadrícula",
        addMainBranch: "Agregar desglose principal",
        resetSettings: "Restablecer ajustes",
        columsToGroup: "Para agrupar datos, use el menú contextual del encabezado de columnas",
        customize: "Personalizar",
        colorType: "Tipo de color",
        formatManagement: "Gestión de formato",
        bottomTotalColumn: "Columna de total inferior",
        formatType: "Tipo de formato",
        datagridSettingsReset: "Se restablecerán los ajustes de la cuadrícula de datos",
        unexpectedError: "Lo sentimos, se ha producido un error inesperado.",
        changesSaved: "Cambios guardados",
        addGantTask: "Agregar tarea Gantt",
        updGantTask: "Actualizar tarea Gantt",
        updSchedulerTask: "Actualizar tarea del calendario",
        updTodoTask: "Actualizar tarea To-Do",
        completeTask: "Completar tarea",
        cantBeEmptyKanban: "El título, el detalle y el usuario asignado no pueden estar vacíos",
        successAdd: "Tarea agregada con éxito",
        successUpd: "Tarea actualizada con éxito",
        errorReadonlyUpd: "No tiene permiso para actualizar la tarea.",
        errorCompletedUpd: "No se puede actualizar una tarea completada.",
        statusChangeTodo: "El estado de finalización de la tarea se cambió con éxito.",
        reminderSended: "Recordatorio enviado con éxito para la tarea",
        askForCompleteTask: "¿Está seguro de que desea completar la tarea?",
        infoForCompletedTask: "Las subtareas asociadas también se completarán.",
        noPermisison: "No tiene permiso.",
        successDependencyAdded: "Dependencia de tarea agregada con éxito",
        filterimportant: "Filtrar por importancia",
        enterEmail: "Ingrese la dirección de correo electrónico",
        reply: "Responder",
        newCol: "Columna nueva",
        thickness: "Grosor",
        distanceToUpperComponent: "Distancia al componente superior",
        companyName: "Nombre de la empresa",
        showEmailModule: "Mostrar módulo de correo",
        distanceToBottomComponent: "Distancia al componente inferior",
        canNonAdminUsersPost: "¿Los usuarios sin permisos de administrador pueden publicar?",
        columnColor: "Color de la columna",
        byWho: "Por",
        updated: "Actualizado",
        commentAdded: "Comentario agregado",
        completed: "Completado",
        addRemoveColumns: "Agregar/Quitar columnas",
        searchMessage: "Buscar en mensajes",
        riverReports: "Informes de River BI",
        forms: "Formularios",
        searchinProcess: "Buscar en procesos",
        searchVoiceMessage: "El mensaje que busca se encuentra en este archivo de audio",
        searchVoiceMessages: "Búsqueda en mensajes de voz",
        showSocialNotifications: "Mostrar notificaciones sociales",
        showProjectManagementNotifications: "Mostrar notificaciones de gestión de proyectos",
        showProcessNotifications: "Mostrar notificaciones de procesos",
        pageDesingPermission: "El usuario no tiene permiso para diseñar páginas.",
        filemanagementDesingPermission: "El usuario no tiene permiso para la gestión de archivos.",
        taskDelete: "La tarea será eliminada.",
        tasksWillDeleted: "¿Está seguro de que desea eliminar la tarea?",
        componentSettings: "Ajustes del componente",
        aboutComponent: "Acerca del componente",
        sureSaveChanges: "¿Está seguro de que desea guardar los cambios realizados?",
        showDeletedNotifications: "Mostrar notificaciones eliminadas",
        shareSometthing: "Comparte algo",
        resetPageLayout: "Restablecer diseño de página",
        downloadingSS: "Descargando captura de pantalla. Por favor espere.",
        showHorizontalLines: "Mostrar líneas horizontales",
        turnOffVerticalHide: "Desactivar ocultación vertical",
        whichVerticalLinesAreToBeHidden: "¿Qué línea(s) vertical(es) no se mostrarán?",
        priority: "Prioridad",
        boardSidebarMessageField: "Campo de mensajes de la tarea",
        boardSidebarExtraField: "Campo de componentes extra de la tarea",
        boardSidebarTaskHistory: "Historial de movimientos",
        loadMoreNotifications: "Mostrar más notificaciones",
        deletedNotifications: "Notificaciones eliminadas",
        noFormNotification: "No hay notificaciones de proceso todavía",
        noDeletedFormNotifications: "No hay notificaciones de proceso eliminadas",
        noDeletedBoardNotification: "No hay notificaciones de tablero eliminadas",
        noBoardNotification: "No hay notificaciones de tablero todavía",
        noDeletedSocialNotification: "No hay notificaciones sociales eliminadas",
        noSocialNotification: "No hay notificaciones sociales todavía",
        deleteAll: "Eliminar todo",
        markAllRead: "Marcar todo como leído",
        board: "Tablero",
        form: "Formulario",
        formNotifications: "Notificaciones de formulario",
        boardNotifications: "Notificaciones de tablero",
        socialNotifications: "Notificaciones sociales",
        email: "Correo electrónico",
        oldFormName: "Nombre antiguo del formulario",
        newFormName: "Nombre nuevo del formulario",
        oldFormVariable: "Variable antigua del formulario",
        newFormVariable: "Variable nueva del formulario",
        oldCategory: "Categoría antigua",
        newCategory: "Categoría nueva",
        connectionInFile: "Conexión en el archivo",
        yourConnection: "Su conexión",
        element: "Elemento",
        script: "Script",
        formClosingEvent: "Evento de cierre del formulario",
        message: "Mensaje",
        formExportTextError: "No hay componentes agregados o el formulario no se ha guardado. Por favor, solucione este problema para evitar errores en la exportación.",
        checkRequiedFields: "Verificar campos obligatorios",
        dontCheckRequiredFields: "No verificar campos obligatorios",
        createPdfWarning: "Si se selecciona, el formulario no se guardará ni se cerrará",
        cratePdf: "Crear PDF",
        identityNumber: "Número de identificación",
        minPaymentHour: "Hora mínima",
        maxPaymentHour: "Hora máxima",
        darkBlue: "Azul oscuro",
        orange: "Naranja",
        component: "Componente",
        properties: "Propiedades",
        dmsPath: "Ruta DMS",
        dashboard: "Panel de control",
        slider: "Control deslizante",
        list: "Lista",
        otherImages: "Otras imágenes",
        unitScript: "Script de unidad",
        updatableMaxQuantity: "Cantidad máxima modificable",
        newPage: "Página nueva",
        code: "Código",
        resetHiddenComponent: "Restablecer el valor de los componentes ocultos",
        bold: "Negrita",
        italic: "Cursiva",
        stringFormat: "Formato de cadena",
        videoUploaded: "Video subido",
        fillInAllFields: "Complete todos los campos",
        normalPaging: "Paginación normal",
        pageSize: "Tamaño de página",
        special: "Especial",
        link: "Enlace",
        fontWeight: "Grosor de la fuente",
        pdfFileNotFound: "Archivo PDF no encontrado",
        likedOn: "le gustó en la fecha",
        subCategory: "Subcategoría",
        toTheBoard: "Al tablero",
        changeTasksPage: "Cambiar el tablero de la tarea",
        hideTaskDetail: "Ocultar detalle de la tarea",
        selectData: "Seleccionar datos",
        noContentYet: "No hay contenido todavía",
        addRowBetween: "Agregar fila en medio",
        userPermissions: "Permisos de usuario",
        askForPassword: "¿Preguntar por contraseña?",
        passwordIsWrong: "Contraseña incorrecta, inténtelo nuevamente.",
        pleaseEnterPassword: "Para continuar, ingrese su contraseña de usuario.",
        onePaymentEachSave: "Un pago por cada guardado",
        riverModules: "Módulos RIVER",
        processHistory: "Historial del proceso",
        commentHasBeenMadeAtThisStage: "Se realizó un comentario en esta etapa",
        clearSelection: "Borrar selección",
        allowDownloadVersionHistoryDocuments: "Permitir la descarga del historial de versiones",
        addNewColor: "Agregar columna nueva",
        delegated: "Delegado",
        openDocxToPdf: "Abrir archivo como PDF",
        activationStartDate: "Fecha de inicio de activación",
        activationEndDate: "Fecha de fin de activación",
        changeActivationDate: "Cambiar fecha de activación",
        showArchive: "Mostrar archivo",
        hideArchive: "Ocultar archivo",
        tasks: "Tareas",
        maxFileCountLimit: "Cantidad máxima de archivos",
        fileCountLimit: "Límite de cantidad de archivos",
        numberOfFilesExceeded: "Se superó la cantidad de archivos",
        numberOfFilesLimit: "Límite de cantidad de archivos",
        lineIntermediateAllowAdd: "Permitir agregar filas intermedias",
        lineIntermediateAllowCopy: "Permitir copiar filas intermedias",
        triggerReport: "Enviar parámetros al informe",
        setWhitePageReportExportName: "Definir el nombre de exportación para el informe de página en blanco",
        menuRowUpdated: "Esta entrada con valor de incremento automático tiene datos asociados. El número de incremento automático se actualizó: ",
        isMenuRowControl: "Control de incremento automático",
        sqlScriptWarning: "El uso de este campo puede causar problemas de rendimiento.",
        deletedTask: "Tarea eliminada",
        getDeletedTasks: "Obtener tareas eliminadas",
        getTasks: "Obtener tareas",
        movePageDesignersNode: "El tablero/menú seleccionado se moverá a la carpeta elegida",
        informationAboutMoveToDirectory: "Los permisos de usuario del tablero/menú trasladado cambiarán según los de la carpeta a la que se mueve.",
        move: "Mover",
        download: "Descargar",
        create: "Crear",
        statistic: "Estadística",
        priRate: "Tasa de asignación según prioridad",
        taskcreatorlist: "Lista de creadores de tarea",
        completionRate: "Tasa de finalización",
        columnsTaskCount: "Cantidad de tareas en las columnas",
        showKanbanFilter: "Mostrar filtros de Kanban",
        showFileHistory: "Mostrar historial del archivo",
        processToStart: "Proceso a iniciar",
        fieldMatching: "Coincidencia de campos",
        dontLetDeleteWhatTheyAdded: "¿Puede eliminar lo que él mismo agregó?",
        myJobs: "Mis tareas",
        excelExportName: "Nombre de exportación a Excel",
        filterSearch: "Búsqueda en tareas",
        filterForAssignUsers: "Filtrar por persona asignada",
        filterForAssignUGroups: "Filtrar por grupo asignado",
        filterForPri: "Filtrar por prioridad",
        clearFilter: "Limpiar filtros",
        makeReadOnly: "Hacer solo lectura",
        letItWorkProcessContinues: "Ejecutar cuando continúe el proceso",
        event: "Evento",
        selectEvent: "Seleccionar evento",
        rowEditor: "Editor de filas",
        formOpeningComponentEvent: "Evento de componente al abrir el formulario",
        addedTask: "agregó",
        updatedTask: "actualizó",
        messageAddedToTask: "mensaje agregado",
        deleteTask: "eliminó",
        completedTask: "completó",
        boardToastNotification: "{{0}} en el tablero {{1}} ha {{3}} la tarea llamada {{2}}",
        socialToastNotification: "{{0}} le gustó tu publicación",
        repostToastNotification: "{{0}} compartió tu publicación nuevamente",
        isReposted: "compartió tu publicación nuevamente.",
        processToastNotification: "{{0}} comentó en el formulario llamado {{1}}",
        yesterday: "Ayer",
        today: "Hoy",
        notSaved: "No se guardó",
        editors: "Editores",
        basic: "Básico",
        file: "Archivo",
        datagridPreferences: "Preferencias de tabla de datos",
        deleteLetsAsk: "Preguntar '¿Eliminar?'",
        addNewRow: "No preguntar, agregar como nueva fila",
        oldRowShouldBeDeleted: "No preguntar, eliminar filas antiguas",
        canBeSearched: "¿Permitir búsqueda?",
        processName: "Nombre del proceso",
        removeReadOnly: "Eliminar modo de solo lectura",
        dontMakeRequired: "Eliminar modo de campo obligatorio",
        generalSettings: "Ajustes generales",
        pageDesignerFirstPage: "Primera página",
        beginDayHour: "Hora de inicio del día",
        endDayHour: "Hora de fin del día",
        dayTimeDuration: "Intervalo de tiempo diario",
        colorSettings: "Ajustes de color",
        colorSettingsDescription: "Color de fondo de los datos.",
        dataName: "Nombre de los datos",
        margin: "Margen",
        rowCount: "Número de filas",
        colCount: "Número de columnas",
        outsideMargin: "Margen externo",
        widgetName: "Nombre del componente",
        searchInProcess: "Formularios de proceso",
        changeEventScriptRun: "¿Ejecutar scripts de evento change al cargar datos?",
        dontChanceId: "(Debido a que este componente se utiliza en el evento del formulario, no se puede cambiar el ID del objeto.)",
        scriptButtonWarning: "El botón de script no es compatible con la configuración de estado en los formularios de menú.",
        infiniteScroll: "Desplazamiento infinito",
        scrollSettings: "Configuración de desplazamiento",
        pageNameSetting: "Ajustes del nombre de la página",
        showPageName: "Mostrar nombre de la página",
        bindProcess: "Vincular proceso a la página",
        bindProcessDetail: "Si se vincula un proceso a la página, esta quedará en modo de solo lectura. Para modificar sus datos, se abrirá el formulario del proceso.",
        description2: "Descripción 2",
        showJobListTabs: "Mostrar pestañas de lista de trabajos",
        showUserPhotosInJobList: "Mostrar fotos de usuario en la lista de trabajos",
        dmsVideoGaleryTabWarning: "No tiene permiso para usar este campo.",
        searchInFormJson: "Buscar dentro del JSON del formulario",
        useExpandedJoblist: "Usar lista de trabajos ampliada",
        editTour: "Editar tour",
        saveAllForm: "Actualizar todos los formularios",
        selectComponent: "Seleccionar componente",
        tourComponents: "Componentes del tour",
        addTourElement: "Agregar elemento al tour",
        startTourWhenFormOpen: "Iniciar el tour cuando se abra el formulario",
        compare: "Comparar",
        tourWillDeleted: "El tour será eliminado",
        deleteTourElement: "Eliminar elemento del tour",
        tourDelete: "Eliminar tour",
        fixedRowHeight: "Altura de fila fija",
        pushWidgetItems: "Desplazar elementos del widget",
        allowMultiLayer: "Permitir modo multicapa",
        gridType: "Tipo de cuadrícula",
        useCollapsedJoblist: "Usar lista de trabajos colapsada",
        searchAllData: "Buscar en todos los datos",
        scriptsRunAllAreSelected: "¿Ejecutar scripts si se seleccionan todos?",
        menuSchedulerPermission: "No tiene permiso para agregar tarjetas de menú",
        showOnTask: "¿Mostrar el editor en procesos?",
        alreadyHaveMenu: "Para usar el componente de menú, el formulario solo puede contener un componente de menú y no se pueden agregar más de uno.",
        select: "Seleccionar",
        startedUserName: "Nombre del usuario que inició",
        startedUserId: "ID del usuario que inició",
        processInstanceId: "Número de proceso",
        formId: "ID del formulario",
        min: "Mínimo",
        difference: "Diferencias entre los dos archivos",
        labelNotFound: "La etiqueta no está definida en este idioma",
        cleanElement: "¿Limpiar el área del elemento al imprimir datos?",
        cleanColumn: "¿Limpiar el área de la columna al imprimir datos?",
        fileSkippedSuccessfully: "Cancelado con éxito.",
        dmsTags: "Etiqueta",
        searchInFormContents: "Buscar en los contenidos del formulario",
        jobType: "Tipo de trabajo",
        workStatus: "Estado de trabajo",
        sendMailManager: "Enviar correo a los gerentes de los usuarios seleccionados",
        or: "O",
        signInWithMicrosoft: "Iniciar sesión con Microsoft",
        receipt: "Recibo",
        receiptOptions: "Opciones de recibo",
        tax: "IVA",
        selectboxWarningMessage: "Debido a que hay más de 100 datos, use el componente de búsqueda. Solo se muestran los primeros 100 valores.",
        degree: "Grado",
        completeDateShort: "Fin:",
        confirmationPopupClose: "Si no realiza ninguna acción, la ventana de confirmación se cerrará automáticamente.",
        confirmationSecondsSetting: "Configuración de tiempo (segundos) para la ventana de confirmación",
        createPdfAndSendForm: "¿Enviar formulario cuando se cree el PDF?",
        confirmCreatePdfAndSendForm: "Se creará un PDF y se enviará el formulario. ¿Confirma?",
        onlyNumbersError: "Debe ingresar un valor que contenga solo números",
        _filter: "Filtrar",
        removeFromFavorites: "Quitar de favoritos",
        addToFavorites: "Agregar a favoritos",
        id: "ID",
        assignedUserName: "Persona/Grupo asignado",
        schemeId: "ID de proceso",
        formStatusByUser: "Descripción",
        formSituationByUser: "Descripción 2",
        isDelegated: "¿El formulario fue delegado?",
        formname: "Nombre del formulario",
        formstatus: "Estado del formulario",
        timeOutDate: "Fecha de vencimiento",
        saveFilterPack: "Guardar paquete de filtros",
        enterRegistrationName: "Ingrese el nombre de registro",
        filterPackages: "Paquetes de filtros",
        speechLengthError: "La grabación supera la duración deseada",
        removeImage: "Eliminar",
        headerBundle: "Elemento de agrupación de encabezado",
        other: "Otro",
        verticalHeader: "Encabezado vertical",
        exportDataAuth: "Permisos de exportación",
        errorFileType: "Tipo de archivo no válido. Tipo aceptado: ",
        folder: "Carpeta",
        page: "Página",
        uploadPdfToDms: "Subir PDF creado a DMS",
        uploadPdfToDmsName: "Ingrese el nombre del PDF para guardarlo en DMS.",
        pdfName: "Nombre del PDF",
        addTour: "Agregar tour",
        updateTour: "Actualizar tour",
        editTourElement: "Editar elemento del tour",
        buttonAction: "Acción del botón",
        referenceArea: "Área de referencia",
        fieldToFill: "Campo a rellenar",
        buttonColor: "Color del botón",
        signFile: "Firmar archivo",
        eSignFile: "Firmar con firma digital (E-firma)",
        addNewCategory: "Agregar nueva categoría",
        autoRefreshJobList: "Actualizar automáticamente la lista de trabajos",
        changeScriptRow: "Cambiar el orden de los scripts",
        defaultRowCheckRequired: "Si hay una fila predeterminada, ¿verificar campos obligatorios?",
        currentCode: "Código contable",
        screenshotOnMobile: "Tomar captura de pantalla en móvil",
        showCallElement: "Mostrar botón de llamada",
        created: "Creado",
        keepPermission: "Al exportar el formulario, también exportar permisos (no se recomienda si sus usuarios o grupos no coinciden)",
        showAddComponentButtonOnDragMenu: "¿Mostrar botón de agregar en el menú de arrastre lateral?",
        editCategory: "Cambiar el nombre de la categoría",
        confirmDeleteCategory: "Confirmar eliminación de la categoría",
        formsWillMoveOnGeneral: "Los formularios de la categoría eliminada se moverán automáticamente a la categoría 'General'.",
        disabledDates: "Fechas no disponibles",
        fileLimitAndSizeRequired: "El tamaño y la cantidad máxima de archivos no pueden estar vacíos",
        relatedFieldChangeDetected: "Se detectó un cambio en el campo relacionado. Se ha limpiado el valor.",
        toastAnonimFormEmailWarning: "En los formularios anónimos, es obligatorio incluir un componente de correo electrónico.",
        toastAnonimFormEmailControlWarning: "Si el formulario de inicio de sesión está activo, el campo de correo electrónico no puede estar vacío.",
        // Anket (Encuesta)
        poll: "Encuesta",
        quickPoll: "Encuesta rápida",
        pollTitle: "Título de la encuesta",
        questionSection: "Sección de pregunta",
        options: "Opciones",
        enterYourQuestion: "Introduzca su pregunta",
        option: "Opción",
        addOption: "Agregar opción",
        selectGroups: "Seleccionar grupos",
        yourQuestionWillAppearHere: "Su pregunta aparecerá aquí",
        optionText: "Opción",
        pollVisibility: "Visibilidad de la encuesta",
        visibleAnytime: "Visible siempre",
        visibleAfterExpiration: "Visible después de la fecha de vencimiento",
        isPostDeleted: "La publicación fue eliminada",
        totalVotes: "Votos totales",
        pollHasEnded: "La encuesta ha terminado",
        pollResults: "Resultados de la encuesta",
        objectFit: "Ajuste de relación de aspecto",
        retweet: "Retwittear",
        retweetNotAllowed: "No se puede retwittear",
        postHasBeenDeleted: "La publicación fue eliminada",
        post: "Publicación",
        pollType: "Tipo de encuesta",
        retweetConfirmation: "¿Está seguro de que desea retwittear esta publicación?",
        addYourThoughts: "Agregue sus comentarios...",
        postContentTooLong: "El contenido de la publicación no puede superar los 500 caracteres",
        pollResultsVisibleAfterExpiration: "Los resultados estarán disponibles una vez finalizada la encuesta",
        pollResultsAnonymous: "Esta encuesta es anónima. No se mostrarán los resultados.",
        loadingPosts: "Cargando publicaciones...",
        generalPoll: "Encuesta general",
        // Bileşenler (Componentes)
        components: "Componentes",
        tabComponents: "Componentes de pestaña",
        allowFloating: "Permitir flotante",
        cellAspectRatio: "Relación de aspecto de la celda",
        cellSpacing: "Espacio entre celdas",
        selectedCardSettings: "Ajustes de la tarjeta seleccionada",
        panelSettings: "Ajustes del panel",
        cannotDragMoreWidget: "No se puede agregar más de un widget a una pestaña.",
        carouselSpeed: "Velocidad del carrusel (ms)",
        carouselMaxPauseOnHover: "Pausa máxima al pasar el ratón (ms)",
        noContentInThisTab: "Aún no se ha agregado contenido a esta pestaña.",
        pageTypeNotSelected: "No se seleccionó tipo de página. No se mostrará ningún contenido.",
        folderSelectionWarning: "Ha seleccionado una carpeta. No se mostrará ningún contenido.",
        menuDisplayUnsupported: "La visualización del menú no está disponible en el diseñador de páginas.",
        noPageSelected: "No se ha seleccionado una página",
        design: "Diseño",
        addCard: "Agregar tarjeta",
        noSettingsForThisWidget: "No hay ajustes disponibles para este componente.",
        
        // Canal y Funcionalidad Social
        invitationRequests: "Solicitudes de invitación",
        youInvitedToFollow: "ha invitado a seguir",
        noInvitationRequests: "No hay solicitudes de invitación",
        noSuggestedPosts: "No hay publicaciones sugeridas",
        back: "Atrás",
        privateChannels: "Canal privado",
        publicChannels: "Canal público",
        myChannels: "Mis canales",
        editChannel: "Editar canal",
        inviteUsers: "Invitar usuarios",
        channelType: "Tipo de canal",
        channelName: "Nombre del canal",
        channelDescription: "Descripción del canal",
        channelImage: "Imagen del canal",
        channelVisibility: "Visibilidad del canal",
        channel: "Canal",
        createNewChannel: "Crear nuevo canal",
        defaultAndFollowed: "Canales seguidos",
        
        // Encuestas y Votaciones
        createNewPoll: "Crear nueva encuesta",
        addAnswer: "Agregar respuesta",
        answerChoices: "Opciones de respuesta",
        noAnswerChoices: "No hay opciones de respuesta",
        areYouSureYouWantToDeleteThisPoll: "¿Está seguro de que desea eliminar esta encuesta?",
        question: "Pregunta",
        multipleChoice: "Opción múltiple",
        closePoll: "Cerrar encuesta",
        openPoll: "Abrir encuesta",
        editPoll: "Editar encuesta",
        answerPoll: "Responder encuesta",
        
        // Funcionalidad de Moderador
        moderatorAffairs: "Asuntos de moderador",
        userManagement: "Gestión de usuarios",
        tabs: "Pestañas",
        bannedUsers: "Usuarios bloqueados",
        bannedInfo: "Información de bloqueo",
        reportedUsers: "Usuarios reportados",
        reportedPosts: "Publicaciones reportadas",
        roleBasedAccess: "Acceso basado en roles",
        unbanUser: "Desbloquear usuario",
        banUser: "Bloquear usuario",
        pendingApproval: "Pendiente de aprobación",
        approveRequest: "Aprobar solicitud",
        rejectRequest: "Rechazar solicitud",
        followUser: "Seguir usuario",
        followingUser: "Siguiendo usuario",
        unfollowUser: "Dejar de seguir",
        followRequest: "Solicitud de seguimiento",
        followRequests: "Solicitudes de seguimiento",
        inviteToChannel: "Invitar al canal",
        hiddenComp: "¿También se deben verificar los componentes ocultos?",

        defaultChannelTypeInfo: "Información del tipo de canal predeterminado",
        enterChannelDescription: "Ingrese la descripción del canal",
        createDefaultChannel: "Crear canal predeterminado",
        channelInformation: "Información del canal",
        channelNameRequired: "¡El nombre del canal es obligatorio!",
        noRecommendedUsers: "No se encontraron usuarios recomendados",
        errorLoadingUsers: "Ocurrió un error al cargar los usuarios",
        errorCreatingUserChannels: "Ocurrió un error al crear los canales de usuario.",
        errorLoadingChannel: "Ocurrió un error al cargar el canal.",





















        //İsmet Can
        receiveImagesWithRowDetails: "Abrir imágenes con detalles de fila en el móvil",
        minFileCountLimit: "Cantidad mínima de archivos",
        minimumFileRequired: "No se cumple el número mínimo de archivos",
        goToPasswordChangePanel: "Ir al panel de cambio de contraseña",

    }
};